<ng-container *ngIf="data.length > 0; else showWarning">
  <ng-container *ngFor="let item of data">
    <app-data-box-item [item]="item" [breakpoint]="breakpoint"></app-data-box-item>
  </ng-container>
</ng-container>
<ng-template #showWarning>
  <app-agres-icons iconsClass="agres-alert-triangle agres-2x"></app-agres-icons>
</ng-template>
